import React from "react";
import { Link } from "react-router-dom";
import { Droplets, Layers, Briefcase, Gift, ArrowRight } from "lucide-react";

const ACCESSORIES = [
  { icon: Droplets, name: "MistPro Spray Bottle", desc: "Professional fine-mist spray for perfect, even dampening before the press.", sku: "MIST-500", price: "₦4,200", compare: "₦5,000" },
  { icon: Layers, name: "SteamPad™", desc: "Reusable pressing pad that creates a steam effect — without a steam iron." },
  { icon: Briefcase, name: "Tailor Edition Kit", desc: "The complete garment-pressing system, built for professional tailors." },
  { icon: Gift, name: "Premium Gift Box", desc: "The CORE 500 and accessories, beautifully boxed for gifting." },
];

export default function EcosystemSection() {
  return (
    <section data-testid="ecosystem-section" className="py-20 md:py-28" style={{ background: "var(--surface-2)", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <div className="eyebrow">The pressing ecosystem</div>
            <h2 className="display mt-4" style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)", color: "var(--ink)" }}>
              More than an iron. <br />
              <em className="italic sunset-text">A complete garment-care system.</em>
            </h2>
          </div>
          <div className="md:col-span-5" style={{ color: "var(--ink-soft)" }}>
            Accessories designed around the CORE 500 — the MistPro Spray Bottle is available now, with more announced here first.
          </div>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ACCESSORIES.map((a) => {
            const I = a.icon;
            const live = Boolean(a.sku);
            const testId = `accessory-${a.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`;
            const card = (
              <>
                <span className="coming-tag" style={{ position: "static", display: "inline-block", ...(live ? { background: "var(--sun-orange)", color: "#fff", borderColor: "var(--sun-orange)" } : {}) }}>
                  {live ? "Available now" : "Coming soon"}
                </span>
                <I size={26} color="var(--sun-orange)" strokeWidth={1.5} className="mt-6" />
                <h3 className="font-serif text-2xl mt-4" style={{ color: "var(--ink)" }}>{a.name}</h3>
                <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>{a.desc}</p>
                {live && (
                  <div className="mt-4 flex items-center gap-2 flex-wrap">
                    <span className="text-xs font-mono line-through" style={{ color: "var(--ink-muted)" }}>{a.compare}</span>
                    <span className="text-base font-medium font-mono" style={{ color: "var(--ink)" }}>{a.price}</span>
                    <span className="inline-flex items-center gap-1 text-sm font-medium sunset-text ml-auto">
                      Shop now <ArrowRight size={13} color="var(--sun-orange)" />
                    </span>
                  </div>
                )}
              </>
            );
            return live ? (
              <Link key={a.name} to={`/products/${a.sku}`} data-testid={testId} className="relative p-8 glossy rounded-2xl block">
                {card}
              </Link>
            ) : (
              <div key={a.name} data-testid={testId} className="relative p-8 glossy rounded-2xl">
                {card}
              </div>
            );
          })}
        </div>

        <Link
          data-testid="ecosystem-page-cta"
          to="/accessories"
          className="mt-10 inline-flex items-center gap-2 text-sm font-medium sunset-text py-2"
        >
          Explore the accessories page <ArrowRight size={15} color="var(--sun-orange)" />
        </Link>
      </div>
    </section>
  );
}
